export const WFRIA_VERSION = "4.0.0-beta.53";
export const DISABLED = "disabled";
export const HIDDEN = "hidden";
export const FOCUSABLE_SELECTORS = `a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]`;
export const PREFIX_SCOPE = "pnr-scope--";
export const PREFIX_MODE = "pnr-mode--";
export const GLOBAL_LIBRARY_VAR = "__WFRIA_GLOBAL__";
export const PAGINATOR_PAGE_SIZES = [10, 20, 50, 100, 200];
export const RESET = "reset";
export const SUBMIT = "submit";
export const TOOLTIP_DISPLAY_DELAY = 2000;
export const TOOLTIP_REMOVE_DELAY = 300;
export const TOOLTIP_SIZE_CLASSNAME_REGEX = /wf-tooltip--(small|medium|large|full)/;
export const TOOLTIP_POSITION_CLASSNAME_REGEX = /wf-tooltip--((left|right)|(top|bottom)-(left|center|right)|((top|bottom)))/;
export const BUTTON_STYLES = ["primary", "standard", "chromeless", "simple"];
export const BUTTON_TYPES = ["button", "submit", "reset"];
export const KEYBOARD_KEYS = {
  BACKSPACE: "Backspace",
  DELETE: "Delete",
  DOWN: "ArrowDown",
  END: "End",
  ENTER: "Enter",
  ESCAPE: "Escape",
  HOME: "Home",
  K: "k",
  LEFT: "ArrowLeft",

  /**
   * When pressing the "alt + k" key combination on a Mac,
   * the resulting event.key values include the following
   * two events:
   * e.key: "Alt"
   * e.key: "˚"
   *
   * Windows browsers yield the following two events:
   * e.key: "Alt"
   * e.key: "k"
   */
  MAC_ALT_K: "˚",
  RIGHT: "ArrowRight",
  SHIFT: "Shift",
  SPACE: " ",
  TAB: "Tab",
  UP: "ArrowUp",
  PAGEUP: "PageUp",
  PAGEDOWN: "PageDown"
};
export const EVENT_TYPES = {
  FOCUS: "focus",
  CLICK: "click",
  KEYDOWN: "keydown",
  KEYUP: "keyup",
  SCROLL: "scroll",
  RESIZE: "resize",
  UNLOAD: "unload",
  TOUCHEND: "touchend",
  MOUSEDOWN: "mousedown",
  MOUSEUP: "mouseup"
};
export const ZINDEX = {
  ACTIVITY_BANNER: 1042,
  MESSAGE_BAR: 1042,
  WAIT_MESSAGE: 1042,
  BALLOON_BUTTON: 1041,
  CALENDAR_BALLOON: 1041,
  MENU_BUTTON: 1041,
  TOOLTIP: 1041,
  TRUNCATION_BALLOON: 1041,
  SESSION_BANNER: 1040,
  SKIP_LINK: 1040,
  NOTIFICATION: 1031,
  MODAL: 1030,
  NAVIGATOR: 1021,
  PAGE_HEADER: 1021,
  VIEW: 1021,
  AUTOCOMPLETE: 1020,
  DROPDOWN: 1020,
  HELP_BUTTON: 1020,
  PAGINATOR: 1020,
  BALLOON: 1000,
  BASE_BALLOON: 1000,
  CEO_NAVIGATOR: 1000,
  HEADER: 1000
};
/**
 * Grid, spacing and Box.
 */

export const DEFAULT_GRID_SPACING = 8;
export const BOX_TSHIRT_NAMES = {
  t: "paddingTop",
  top: "paddingTop",
  r: "paddingRight",
  right: "paddingRight",
  b: "paddingBottom",
  bottom: "paddingBottom",
  l: "paddingLeft",
  left: "paddingLeft"
};
export const BOX_TSHIRT_SIZES = {
  xs: 0.5,
  sm: 1,
  m: 2,
  l: 3,
  xl: 4,
  xxl: 5
};
/**
 * Popup.
 */

export const POPUP_PREFIX = "pnr-popup";
export const POPUP_ROOT = `${POPUP_PREFIX}-root`;
export const BUTTON = "Button";
export const MENUITEM = "MenuItem";
export const MENUITEMGROUP = "MenuItemGroup";
export const MENU_BUTTON_EXPAND_ANIMATION_TIME = 250;
/** Keyboard Navigator Modes. */

export const KEYBOARD_NAVIGATOR_MODE = {
  HORIZONTAL: "HORIZONTAL",
  VERTICAL: "VERTICAL",
  BOTH: "BOTH"
};
/**
 * react-transition-group used to export these variables. In order to
 * keep things consistent in our code, we centralize them here.
 */

export const EXITED = "exited";
export const ENTERING = "entering";
export const ENTERED = "entered";
export const EXITING = "exiting";
/** Time constants */

export const ONE_SECOND = 1000;
export const THREE_SECONDS = 3000;
export const DESCRIBEDBY_TIMEOUT = 200;
export const TEN_SECONDS = 10 * ONE_SECOND;
export const DELAY_TIME = 500;
/** NavBar */

export const NAVLINK = "NavLink";
export const LINK = "Link";
export const NAVBARITEM = "NavBarItem";
export const MEGAMENU = "MegaMenu";
export const MEGAMENUITEMGROUP = "MegaMenuItemGroup";
export const MEGAMENUITEM = "MegaMenuItem";
/** Zoom at 400% results in 320px */

export const ZOOM_400_MAX_WIDTH = 320;